import { BrandLogo } from '@/components/BrandLogo';

export const CURSOR_PLACEHOLDER = '\u200B';

interface Props {
  whitespace?: boolean;
  label?: string;
}

export default function BlinkingCursor({
  whitespace,
  label = 'Thinking'
}: Props) {
  if (whitespace) {
    return (
      <span
        aria-hidden="true"
        className="ml-1 inline-block h-[1.15em] w-0.5 translate-y-0.5 rounded-full bg-primary align-baseline animate-pulse"
      />
    );
  }

  return (
    <div className="copilot-thinking-row my-2 flex w-fit items-start gap-2.5">
      <BrandLogo
        size="avatar"
        variant="mark"
        className="assistant-thinking-avatar mt-0.5"
      />
      <div
        role="status"
        aria-label={`IPMA Copilot: ${label}`}
        className="copilot-thinking pt-1.5 text-[13px] font-semibold tracking-[-0.01em] text-muted-foreground"
      >
        <span className="copilot-thinking-text">
          {label}
          <span aria-hidden="true" className="copilot-thinking-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </span>
      </div>
    </div>
  );
}
